import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { ILocationState } from '../core/router/getLocationState';

const locationKey = 'authRedirect';

/**
 * Salviamo nel sessionStorage il path di navigazione ottenuto prima del redirect alla pagina di login.
 * Ci permette di reindirizzare l'utente alla pagina originale dopo l'autenticazione con IdP terzi.
 */
export function useSessionStorageLocation() {
  const { state } = useLocation<ILocationState>();

  useEffect(() => {
    if (state?.from?.pathname) {
      sessionStorage.setItem(locationKey, state.from.pathname);
    }
  }, [state]);
}

export function getSessionStorageLocation() {
  return sessionStorage.getItem(locationKey);
}

/**
 * Recupera il path di navigazione salvato nel sessionStorage e lo rimuove.
 */
export function popSessionStorageLocation() {
  const location = getSessionStorageLocation();
  sessionStorage.removeItem(locationKey);
  return location;
}
